<template>
  <div>
    <NavBar>
      <template #left>
        <BackButton @click="changeStep(EProductsAcquisitionSteps.PRODUCTS)" />
      </template>
      <template #right>
        <ButtonIconContextual
          data-testid="bt-deletar-produto"
          label="Deletar produto"
          aria-label="Deletar produto"
          :icon="isDeleteMode ? 'EF0030' : 'EE0010'"
          @click="handleDeleteMode"
        />
      </template>
    </NavBar>
    <SelectedProductList
      :products="productList"
      :is-delete-active="isDeleteMode"
      @show-wallet-selection="changeStep(EProductsAcquisitionSteps.PRODUCTS)"
      @disable-delete-mode="isDeleteMode = false"
    />
  </div>
</template>

<script lang="ts" setup>
import { inject, ref, Ref } from 'vue';

import { NavBar, ButtonIconContextual } from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { SelectedProductList } from './components/SelectedProductList';

import { EProductsAcquisitionSteps } from '@/modules/catalog/views/ProductsAcquisition/helpers';

import { IProductGetLastState } from '@/modules/catalog/services/products-acquisition';

const productList = inject('productList') as Ref<IProductGetLastState[]>;

const changeStep = inject('changeStep', (step: EProductsAcquisitionSteps) => ({
  step
}));

const isDeleteMode = ref(false);

function handleDeleteMode() {
  isDeleteMode.value = !isDeleteMode.value;
}
</script>
